export function getDeviceId(vehicle: uui.domain.client.UnifiedVehicle) {
  if (!vehicle.isPhysicalDevice) return
  return vehicle.device.deviceId
}
